export const ESTADOANUNCIOS = [
    {
        nombre: 'Publicado',
        color: '#495BFF'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },

]

export const ESTADOSPQRS = [
    {
        nombre: 'Nuevo',
        color: '#495BFF'
    },
    {
        nombre: 'Resuelta',
        color: '#5EA4EC'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]

export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: '#495BFF'
    },
    {
        nombre: 'Admin',
        color: '#5EA4EC'
    },
    {
        nombre: 'Suspendido',
        color: '#808080'
    },
]